/**
 * This package's translations, registered at import.
 *
 * French and English only, like the other product features: the product is
 * French (§6 of `docs/product/cadrage-hardauto.md`) and English is the parity
 * reference and i18next's fallback.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "catalog";

registerNamespace(NAMESPACE, { en, fr });
